import { TbSitemap } from 'react-icons/tb';

import FamilyEditDeleteIcons from '../components/FamilyEditDeleteIcons';
import { familyMessages } from '../variables/familyMessages';

export const buildCheckTableModalProps = (
	module,
	data,
	onDelete,
	onCreateClick
) => {
	switch (module) {
		case 'família':
			return {
				filterModule: 'family',
				columnsData: [
					{
						Header: ' ',
						accessor: 'CheckBox',
						disableSortBy: true,
						type: 'checkBox',
						filter: false,
					},
					{
						Header: familyMessages.LABELS.FAMILY_NAME_HEADER,
						accessor: 'nome_familia',
						type: 'text',
						optional: true,
						filter: 'includesIgnoreCase',
						hover: familyMessages.HOVER.FAMILY_NAME,
					},
					{
						Header: ' ',
						type: 'jsx',
						accessor: 'button',
						jsx: FamilyEditDeleteIcons,
						filter: false,
					},
				],
				modalTitle: familyMessages.SCREEN_TITLES.FAMILIES,
				modalIcon: TbSitemap,
				modalIconColor: 'easyRED.300',
				modalTitleColor: 'easyBLUE.300',
				showCreateButton: true,
				createButtonText: familyMessages.LABELS.CREATE_FAMILY,
				onCreateClick: onCreateClick,
				data: data,
				renderRow: family => {
					return {
						...family,
						CheckBox: family.id,
						button: {
							selectedId: family.id,
							filterModule: 'family',
							rowData: family,
						},
					};
				},
				onDelete: onDelete,
				simpleDelete: {
					provider: 'family',
					toastSuccessTitle:
						familyMessages.MSG_FAMILY_DELETED_SUCCESS,
					toastSuccessDescription:
						familyMessages.MSG_FAMILY_DELETED_SUCCESS,
					toastErrorTitle: familyMessages.MSG_FAMILY_DELETE_ERROR,
					title: familyMessages.MSG_CONFIRM_DELETE_FAMILY,
					text: [
						familyMessages.DESCRIPTION.FAMILY_DELETE,
						'',
						familyMessages.MSG_CONFIRM_DELETE_FINAL,
					],
					invalidate: 'family-list',
				},
				deleteMany: [familyMessages.DESCRIPTION.FAMILIES_DELETE, ''],
				deleteAll: {
					provider: 'family',
					toastSuccessTitle: familyMessages.MSG_DELETE_ALL_SUCCESS,
					toastSuccessDescription:
						familyMessages.MSG_FAMILIES_DELETE_ALL_SUCCESS,
					toastErrorTitle:
						familyMessages.MSG_FAMILIES_DELETE_ALL_ERROR,
					invalidate: 'family-list',
				},
			};
		case 'subfamília':
			return {
				filterModule: 'subfamily',
				columnsData: [
					{
						Header: ' ',
						accessor: 'CheckBox',
						disableSortBy: true,
						type: 'checkBox',
						filter: false,
					},
					{
						Header: familyMessages.LABELS.SUBFAMILY_NAME_HEADER,
						accessor: 'nome_sub_familia',
						type: 'text',
						optional: true,
						filter: 'includesIgnoreCase',
						hover: familyMessages.HOVER.SUBFAMILY_NAME,
					},
					{
						Header: ' ',
						type: 'jsx',
						accessor: 'button',
						jsx: FamilyEditDeleteIcons,
						filter: false,
					},
				],
				modalTitle: familyMessages.SCREEN_TITLES.SUBFAMILIES,
				modalIcon: TbSitemap,
				modalIconColor: 'easyRED.300',
				modalTitleColor: 'easyBLUE.300',
				showCreateButton: true,
				createButtonText: familyMessages.LABELS.CREATE_SUBFAMILY,
				onCreateClick: onCreateClick,
				data: data,
				renderRow: subFamily => {
					return {
						...subFamily,
						CheckBox: subFamily.id,
						button: {
							selectedId: subFamily.id,
							filterModule: 'subfamily',
							rowData: subFamily,
						},
					};
				},
				onDelete: onDelete,
				simpleDelete: {
					provider: 'subfamily',
					toastSuccessTitle:
						familyMessages.MSG_SUBFAMILY_DELETED_SUCCESS,
					toastSuccessDescription:
						familyMessages.MSG_SUBFAMILY_DELETED_SUCCESS,
					toastErrorTitle: familyMessages.MSG_SUBFAMILY_DELETE_ERROR,
					title: familyMessages.MSG_CONFIRM_DELETE_SUBFAMILY,
					text: [
						familyMessages.DESCRIPTION.SUBFAMILY_DELETE,
						'',
						familyMessages.MSG_CONFIRM_DELETE_FINAL,
					],
					invalidate: 'subfamily-list',
				},
				deleteMany: [familyMessages.DESCRIPTION.SUBFAMILIES_DELETE, ''],
				deleteAll: {
					provider: 'subfamily',
					toastSuccessTitle: familyMessages.MSG_DELETE_ALL_SUCCESS,
					toastSuccessDescription:
						familyMessages.MSG_SUBFAMILIES_DELETE_ALL_SUCCESS,
					toastErrorTitle:
						familyMessages.MSG_SUBFAMILIES_DELETE_ALL_ERROR,
					invalidate: 'subfamily-list',
				},
			};
		case 'modelo':
			return {
				filterModule: 'model-product',
				columnsData: [
					{
						Header: ' ',
						accessor: 'CheckBox',
						disableSortBy: true,
						type: 'checkBox',
						filter: false,
					},
					{
						Header: familyMessages.LABELS.MODEL_NAME_HEADER,
						accessor: 'nome_modelo',
						type: 'text',
						optional: true,
						filter: 'includesIgnoreCase',
						hover: familyMessages.HOVER.MODEL_NAME,
					},
					{
						Header: ' ',
						type: 'jsx',
						accessor: 'button',
						jsx: FamilyEditDeleteIcons,
						filter: false,
					},
				],
				modalTitle: familyMessages.SCREEN_TITLES.MODELS,
				modalIcon: TbSitemap,
				modalIconColor: 'easyRED.300',
				modalTitleColor: 'easyBLUE.300',
				showCreateButton: true,
				createButtonText: familyMessages.LABELS.CREATE_MODEL,
				onCreateClick: onCreateClick,
				data: data,
				renderRow: model => {
					return {
						...model,
						CheckBox: model.id,
						nome_modelo: model.nome_modelo,
						button: {
							selectedId: model.id,
							filterModule: 'model-product',
							rowData: model,
						},
					};
				},
				onDelete: onDelete,
				simpleDelete: {
					provider: 'productModel',
					toastSuccessTitle: familyMessages.MSG_MODEL_DELETED_SUCCESS,
					toastSuccessDescription:
						familyMessages.MSG_MODEL_DELETED_SUCCESS,
					toastErrorTitle: familyMessages.MSG_MODEL_DELETE_ERROR,
					title: familyMessages.MSG_CONFIRM_DELETE_MODEL,
					text: [
						familyMessages.DESCRIPTION.MODEL_DELETE,
						'',
						familyMessages.MSG_CONFIRM_DELETE_FINAL,
					],
					invalidate: 'model-product-list',
				},
				deleteMany: [familyMessages.DESCRIPTION.MODELS_DELETE, ''],
				deleteAll: {
					provider: 'productModel',
					toastSuccessTitle: familyMessages.MSG_DELETE_ALL_SUCCESS,
					toastSuccessDescription:
						familyMessages.MSG_MODELS_DELETE_ALL_SUCCESS,
					toastErrorTitle: familyMessages.MSG_MODELS_DELETE_ALL_ERROR,
					invalidate: 'model-product-list',
				},
			};
		default:
			throw new Error('Módulo não implementado!');
	}
};
